<template>
  <mw-dialog size="large_large" title="修改读作者域" :footerButton="footerButton" ref="dialog" @closed="handleClose">
    <div style="height:100%">
      <div class="mw-toolbar">
        <el-button @click="addAuthorAuthority()">分配作者域权限</el-button>
        <el-button @click="addReaderAuthority()">分配读者域权限</el-button>
        <el-button type="danger" @click="deleteAuthority()">删除</el-button>
      </div>
      <div class="mw-toolbar__body">
        <el-table style="height:100%" height="100%" border ref="table" :data="authorityList">
          <el-table-column type=selection />
          <el-table-column prop="name" label="授权对象名" />
          <el-table-column prop="id" label="授权对象ID" />
          <el-table-column prop="type" label="授权类型">
            <template slot-scope="scope">
              <span v-if="scope.row.type==='authors'">作者域</span>
              <span v-if="scope.row.type==='readers'">读者域</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <mw-dialog size="small_large" :title="dialog2Title" :footerButton="footerButton2" ref="dialog2">
        <authority-editor v-model="currentAuthority" />
      </mw-dialog>
    </div>
  </mw-dialog>
</template>

<script>
import api from "@/common/api/maintain";
import AuthorityEditor, { USEDID } from "./authorityEditor.vue";

export default {
  data() {
    return {
      footerButton: [
        {
          label: "取消",
          func: () => {
            this.mwRef("dialog").hide();
          }
        }
      ],

      footerButton2: [
        {
          label: "取消",
          func: () => {
            this.mwRef("dialog2").hide();
          }
        },
        {
          label: "确定",
          func: async () => {
            const { success } = await api.coverAuthority({
              businessId: this.businessId,
              authObjIds: this.currentAuthority.map(x => x[USEDID]),
              authType: this.currentAuthorityType,
              formKey: this.formKey
            });
            if (success) {
              this.mwMsg("添加成功.");
              this.currentAuthority = [];
              this.mwRef("dialog2").hide();
              this.getAuthorityList();
            }
          }
        }
      ],

      authorityList: [],
      businessId: "",
      applicationId: "",
      moduleId: "",
      formKey: "",

      currentAuthority: [],
      currentAuthorityType: "",
      dialog2Title: ''
    };
  },

  methods: {
    async submit() {},

    async action({ applicationId, businessId, moduleId, formEntityKey }) {
      this.mwRef("dialog").show();

      this.businessId = businessId;
      this.applicationId = applicationId;

      this.moduleId = moduleId;
      this.formKey = formEntityKey;

      this.getAuthorityList();
    },

    handleClose() {
      // this.$refs.formView.teardown();
    },

    async getAuthorityList() {
      const {
        result: authorsList,
        totalCount: total
      } = await this.mwApi.maintain.listAuthority({
        businessId: this.businessId,
        formKey: this.formKey
      });
      this.total = parseInt(total, 10) || 0;
      this.authorityList = authorsList;
    },

    addAuthorAuthority() {
      this.addAuthority("authors");
    },

    addReaderAuthority() {
      this.addAuthority("readers");
    },

    async deleteAuthority() {
      const { selection } = this.$refs.table;
      // if (selection.length === 0) return;
      if (await this.$confirm("您是否确定要删除？")) {
        if (
          await api.deleteAuthority({
            businessId: this.businessId,
            formKey: this.formKey,
            authReaderObjs: selection.map(x => {
              return {
                objId: x.id,
                authType: x.type
              }
            })
          })
        ) {
          this.mwMsg("删除成功.");
          this.getAuthorityList();
        }
      }
    },

    addAuthority(type) {
      const { selection } = this.$refs.table;
      // if (selection.length === 0) return;
      this.currentAuthority = this.authorityList
        .filter(x => x.type === type)
        .map(x => ({ ...x, label: x.name }));
      this.currentAuthorityType = type;
      this.dialog2Title = {
        'authors': '修改作者域',
        'readers': '修改读者域',
      }[type];
      this.$refs.dialog2.show();
    }
  },

  components: {
    AuthorityEditor
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/modules/index/views/systemSet/set/flowInterfering/actions/editAuthority.vue